/**
 * Mounts the guided onboarding for a role and offers it on first meaningful
 * login. Once completed or dismissed it does not reappear automatically.
 */
import { useEffect, useState } from "react";
import OnboardingDialog from "./OnboardingDialog";
import { useOnboarding } from "@/hooks/useOnboarding";
import type { OnboardingAudience } from "@/lib/onboarding/tours";

interface Props {
  audience: OnboardingAudience;
}

export default function OnboardingLauncher({ audience }: Props) {
  const { state, loading, hasNewerVersion } = useOnboarding(audience);
  const [open, setOpen] = useState(false);
  const [offered, setOffered] = useState(false);

  useEffect(() => {
    if (loading || offered) return;
    if (state.status === "not_started" || state.status === "in_progress" || hasNewerVersion) {
      setOffered(true);
      setOpen(true);
    }
  }, [loading, offered, state.status, hasNewerVersion]);

  if (loading) return null;

  return <OnboardingDialog audience={audience} open={open} onOpenChange={setOpen} />;
}
